import React from "react";
import moment from 'moment';

import Spinner from "../../../../UI/Spinner/Spinner";

import FlightInfoContainer from './FlightInfoContainer/FlightInfoContainer';
import FlightInfoBoxOuter from './FlightInfoBoxOuter/FlightInfoBoxOuter';
import FlightInfoBoxInnerLeft from './FlightInfoBoxInnerLeft/FlightInfoBoxInnerLeft';
import FlightInfoBoxInnerRight from './FlightInfoBoxInnerRight/FlightInfoBoxInnerRight';
import InfoLabel from './FlightInfoLayover/FlightInfoLayover';
import Note from './FlightNote/FlightNote';


const flightInfo = (props) => {
    let flights = <Spinner />;
    const flightSchedule =  props.flightSchedule[0].FS[0];
    const baggage = props.flightSchedule[0].FS[0].bga;
    const meal = props.flightSchedule[0].FS[0].ml;
    const techStopover = props.isIntFlight && flightSchedule.so ? "Via " + flightSchedule.so.name : flightSchedule.so;
    

    if (props.flightSchedule !== null) {
      const departureTerminal = flightSchedule.dt;
      const arrivalTerminal = flightSchedule.at;
      const flightStatus = flightSchedule.ft;
      const flightNumberInitial = flightSchedule.ac;
      const flightNumberDigit = flightSchedule.fl;
      const classType = flightSchedule.classtype;
      const operatingAirline = props.airlineNames[flightSchedule.ac];
  
      const origin = flightSchedule.dac;
      const destination = flightSchedule.aac;
      const originCity = props.cityNames[origin];
      const destinationCity = props.cityName ? props.cityName[destination] : props.cityNames[destination];
      const originAirport = props.airportNames[origin];
      const destinationAirport = props.airportNames[destination];
  
      // Departure Dates
      const departureDate = flightSchedule.ddt;
  
      const dDate = departureDate.split('-')[2];
      const dMonth = moment(departureDate, 'YYYY-MM-DD').format('MMM');
      const dDay = moment(departureDate, 'YYYY-MM-DD').format('ddd');
  
      // Arrival Dates
      const arrivalDate = flightSchedule.adt;
  
      const aDate = arrivalDate.split('-')[2];
      const aMonth = moment(arrivalDate, 'YYYY-MM-DD').format('MMM');
      const aDay = moment(arrivalDate, 'YYYY-MM-DD').format('ddd');
  
      const departureTime = flightSchedule.dd;
      const arrivalTime = flightSchedule.ad;
      const durationTime = flightSchedule.du;
  
      const airlineCode = flightSchedule.ac;
      const aircraftName = flightSchedule.eq;

  
      if (props.flightSchedule[0].FS.length === 1) {
        flights = (
          <React.Fragment>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft 
                airlineCode={airlineCode} 
                operatingAirline={operatingAirline} 
                flightNumberInitial={flightNumberInitial} 
                flightNumberDigit={flightNumberDigit} 
                classType={classType}
                aircraftName={aircraftName}
                flightStatus={flightStatus} />
              <FlightInfoBoxInnerRight 
                departureTime={departureTime}
                origin={origin}
                originCity={originCity}
                dDate={dDate}
                departureMonthUpdated={dMonth}
                departureDayUpdated={dDay}
                originAirport={originAirport}
                departureTerminal={departureTerminal}
                durationTime={durationTime}
                destination={destination}
                destinationCity={destinationCity}
                arrivalTime={arrivalTime}
                aDate={aDate}
                arrivalMonthUpdated={aMonth}
                arrivalDayUpdated={aDay}
                destinationAirport={destinationAirport}
                arrivalTerminal={arrivalTerminal}
                techStopover={techStopover}
                baggage={baggage}
                meal={meal}/>
            </FlightInfoBoxOuter>
            {props.isIntFlight ? <div className="mt-3"><Note>Passenger of all Nationalities are advised to confirm with respective embassies for all visa requirements.This communication is for informational &amp; general purposes only &amp; Yatra assumes no responsibility,legal or otherwise,of its applicability &amp; accuracy.</Note></div> : null}
            {baggage === "Hand Baggage only" ? <div className={`phone-ml-0 mt-5 pl-28Percent phone-pl-0`}><div className="mt-1"><InfoLabel type="handBaggage" /></div></div> : null}
          </React.Fragment>
        );
      } else if (
        props.flightSchedule[0].FS.length === 2
      ) {
        const fsOne = props.flightSchedule[0].FS[0];
        const baggageOne = props.flightSchedule[0].FS[0].bga;
        const mealOne = props.flightSchedule[0].FS[0].ml;
        const techStopoverOne = props.isIntFlight && props.flightSchedule[0].FS[0].so ? "Via " + props.flightSchedule[0].FS[0].so.name : props.flightSchedule[0].FS[0].so;
        const fsTwo = props.flightSchedule[0].FS[1];
        const baggageTwo = props.flightSchedule[0].FS[1].bga;
        const mealTwo = props.flightSchedule[0].FS[1].ml;
        const aircraftNameTwo = fsTwo.eq;
        const techStopoverTwo = props.isIntFlight && props.flightSchedule[0].FS[1].so ? "Via " + props.flightSchedule[0].FS[1].so.name : props.flightSchedule[0].FS[1].so;
        const departureTerminalTwo = fsTwo.dt;
        const arrivalTerminalTwo = fsTwo.at;
        const flightStatusTwo = fsTwo.ft;
        const flightNumberInitialTwo = fsTwo.ac;
        const flightNumberDigitTwo = fsTwo.fl;
        const classTypeTwo = fsTwo.classtype;
        const operatingAirlineTwo = props.airlineNames[fsTwo.ac];
        const isTvOne = props.flightSchedule[0].FS[0].tv === "1";
  
        const originTwo = fsTwo.dac;
        const destinationTwo = fsTwo.aac;
        const originCityTwo = props.cityNames[originTwo];
        const destinationCityTwo = props.cityName ? props.cityName[destinationTwo] : props.cityNames[destinationTwo];
        const originAirportTwo = props.airportNames[originTwo];
        const destinationAirportTwo =
          props.airportNames[destinationTwo];
  
        // Departure Dates
        const departureDateTwo = fsTwo.ddt;
  
        const dDateTwo = departureDateTwo.split('-')[2];
        const dMonthTwo = moment(departureDateTwo, 'YYYY-MM-DD').format('MMM');
        const dDayTwo = moment(departureDateTwo, 'YYYY-MM-DD').format('ddd');
  
        // Arrival Dates
        const arrivalDateTwo = fsTwo.adt;
  
        const aDateTwo = arrivalDateTwo.split('-')[2];
        const aMonthTwo = moment(arrivalDateTwo, 'YYYY-MM-DD').format('MMM');
        const aDayTwo = moment(arrivalDateTwo, 'YYYY-MM-DD').format('ddd');
  
        const arrivalTimeOne = fsOne.ad;
        const departureTimeTwo = fsTwo.dd;
        const arrivalTimeTwo = fsTwo.ad;
        const durationTimeTwo = fsTwo.du;
        const startTime =  moment(fsOne.adt + " " + arrivalTimeOne);
        const endTime = moment(fsTwo.ddt + " " + departureTimeTwo);
        const duration = moment.duration(endTime.diff(startTime));
        const hours = parseInt(duration.asHours(), 10);
        const minutes = parseInt(duration.asMinutes(), 10)-hours*60;
        const layoverTime = hours + 'h ' + minutes + 'm';

        flights = (
          <React.Fragment>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft 
                airlineCode={airlineCode} 
                operatingAirline={operatingAirline} 
                flightNumberInitial={flightNumberInitial} 
                flightNumberDigit={flightNumberDigit}
                classType={classType}
                aircraftName={aircraftName}
                flightStatus={flightStatus} />
              <FlightInfoBoxInnerRight 
                departureTime={departureTime}
                origin={origin}
                originCity={originCity}
                dDate={dDate}
                departureMonthUpdated={dMonth}
                departureDayUpdated={dDay}
                originAirport={originAirport}
                departureTerminal={departureTerminal}
                durationTime={durationTime}
                destination={destination}
                destinationCity={originCityTwo}
                arrivalTime={arrivalTime}
                aDate={aDate}
                arrivalMonthUpdated={aMonth}
                arrivalDayUpdated={aDay}
                destinationAirport={destinationAirport}
                arrivalTerminal={arrivalTerminal}
                techStopover={techStopoverOne}
                baggage={baggageOne}
                meal={mealOne}/>
            </FlightInfoBoxOuter>
            <div className={`phone-ml-0 mt-5 mb-5 pl-28Percent phone-pl-0`}>
              <InfoLabel type="layover" originCity={originCityTwo} layoverTime={layoverTime} />
              {isTvOne ? <div className="mt-1"><InfoLabel type="transitVisa" originCity={originCityTwo} /></div> : null}
              {baggageOne === "Hand Baggage only" ? <div className="mt-1"><InfoLabel type="handBaggage" /></div> : null}
            </div>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft 
                airlineCode={airlineCode} 
                operatingAirline={operatingAirlineTwo} 
                flightNumberInitial={flightNumberInitialTwo} 
                flightNumberDigit={flightNumberDigitTwo} 
                classType={classTypeTwo}
                aircraftName={aircraftNameTwo}
                flightStatus={flightStatusTwo} />
              <FlightInfoBoxInnerRight 
                departureTime={departureTimeTwo}
                origin={originTwo}
                originCity={originCityTwo}
                dDate={dDateTwo}
                departureMonthUpdated={dMonthTwo}
                departureDayUpdated={dDayTwo}
                originAirport={originAirportTwo}
                departureTerminal={departureTerminalTwo}
                durationTime={durationTimeTwo}
                destination={destinationTwo}
                destinationCity={destinationCityTwo}
                arrivalTime={arrivalTimeTwo}
                aDate={aDateTwo}
                arrivalMonthUpdated={aMonthTwo}
                arrivalDayUpdated={aDayTwo}
                destinationAirport={destinationAirportTwo}
                arrivalTerminal={arrivalTerminalTwo}
                techStopover={techStopoverTwo}
                baggage={baggageTwo}
                meal={mealTwo}/>
            </FlightInfoBoxOuter>
            {props.isIntFlight ? <div className="mt-3"><Note>Passenger of all Nationalities are advised to confirm with respective embassies for all visa requirements.This communication is for informational &amp; general purposes only &amp; Yatra assumes no responsibility,legal or otherwise,of its applicability &amp; accuracy.</Note></div> : null}
          </React.Fragment>
        );
      } else if (
        props.flightSchedule[0].FS.length === 3
      ) {
        // Second Flight Logic Start
        const fsTwo = props.flightSchedule[0].FS[1];
        const baggageTwo = props.flightSchedule[0].FS[1].bga;
        const mealTwo = props.flightSchedule[0].FS[1].ml;
        const techStopoverTwo = props.isIntFlight && props.flightSchedule[0].FS[1].so ? "Via " + props.flightSchedule[0].FS[1].so.name : props.flightSchedule[0].FS[1].so;
        const departureTerminalTwo = fsTwo.dt;
        const aircraftNameTwo = fsTwo.eq;
        const arrivalTerminalTwo = fsTwo.at;
        const flightStatusTwo = fsTwo.ft;
        const flightNumberInitialTwo = fsTwo.ac;
        const flightNumberDigitTwo = fsTwo.fl;
        const classTypeTwo = fsTwo.classtype;
        const operatingAirlineTwo = props.airlineNames[fsTwo.ac];
  
        const originTwo = fsTwo.dac;
        const destinationTwo = fsTwo.aac;
        const originCityTwo = props.cityNames[originTwo];
        const originAirportTwo = props.airportNames[originTwo];
        const destinationAirportTwo =
          props.airportNames[destinationTwo];
  
        // Departure Dates
        const departureDateTwo = fsTwo.ddt;
  
        const dDateTwo = departureDateTwo.split('-')[2];
        const dMonthTwo = moment(departureDateTwo, 'YYYY-MM-DD').format('MMM');
        const dDayTwo = moment(departureDateTwo, 'YYYY-MM-DD').format('ddd');
  
        // Arrival Dates
        const arrivalDateTwo = fsTwo.adt;
  
        const aDateTwo = arrivalDateTwo.split('-')[2];
        const aMonthTwo = moment(arrivalDateTwo, 'YYYY-MM-DD').format('MMM');
        const aDayTwo = moment(arrivalDateTwo, 'YYYY-MM-DD').format('ddd');
        
        const arrivalTimeOne = flightSchedule.ad;
        const departureTimeTwo = fsTwo.dd;
        const arrivalTimeTwo = fsTwo.ad;
        const durationTimeTwo = fsTwo.du;
        const startTime = moment(flightSchedule.adt + " " + arrivalTimeOne);
        const endTime = moment(fsTwo.ddt + " " + departureTimeTwo);
        const duration = moment.duration(endTime.diff(startTime));
        const hours = parseInt(duration.asHours(), 10);
        const minutes = parseInt(duration.asMinutes(), 10)-hours*60;
        const layoverTimeOne = hours + 'h ' + minutes + 'm';
        const isTvOne = props.flightSchedule[0].FS[0].tv === "1";
        const isTvTwo = props.flightSchedule[0].FS[1].tv === "1";
  
        // Second Flight Logic End
  
  
        // Third Flight Logic Start
  
        const fsThree = props.flightSchedule[0].FS[2];
        const baggageThree = props.flightSchedule[0].FS[2].bga;
        const mealThree = props.flightSchedule[0].FS[2].ml;
        const techStopoverThree = props.isIntFlight && props.flightSchedule[0].FS[2].so ? "Via " + props.flightSchedule[0].FS[2].so.name : props.flightSchedule[0].FS[2].so;
        const departureTerminalThree = fsThree.dt;
        const arrivalTerminalThree = fsThree.at;
        const aircraftNameThree = fsThree.eq;
        const flightStatusThree = fsThree.ft;
        const flightNumberInitialThree = fsThree.ac;
        const flightNumberDigitThree = fsThree.fl;
        const classTypeThree = fsThree.classtype;
        const operatingAirlineThree = props.airlineNames[fsThree.ac];
  
        const originThree = fsThree.dac;
        const destinationThree = fsThree.aac;
        const originCityThree = props.cityNames[originThree];
        const destinationCityThree = props.cityName ? props.cityName[destinationThree] : props.cityNames[destinationThree];
        const originAirportThree = props.airportNames[originThree];
        const destinationAirportThree =
          props.airportNames[destinationThree];
  
        // Departure Dates
        const departureDateThree = fsThree.ddt;
  
        const dDateThree = departureDateThree.split('-')[2];
        const dMonthThree = moment(departureDateThree, 'YYYY-MM-DD').format('MMM');
        const dDayThree = moment(departureDateThree, 'YYYY-MM-DD').format('ddd');
  
        // Arrival Dates
        const arrivalDateThree = fsThree.adt;
  
        const aDateThree = arrivalDateThree.split('-')[2];
        const aMonthThree = moment(arrivalDateThree, 'YYYY-MM-DD').format('MMM');
        const aDayThree = moment(arrivalDateThree, 'YYYY-MM-DD').format('ddd');
        const departureTimeThree = fsThree.dd;
        const arrivalTimeThree = fsThree.ad;
        const durationTimeThree = fsThree.du;
  
        const startTimeTwo = moment(fsTwo.adt + " " + arrivalTimeTwo);
        const endTimeTwo = moment(fsThree.ddt + " " + departureTimeThree);
        const durationTwo = moment.duration(endTimeTwo.diff(startTimeTwo));
        const hoursTwo = parseInt(durationTwo.asHours(), 10);
        const minutesTwo = parseInt(durationTwo.asMinutes(), 10)-hoursTwo*60;
        const layoverTimeTwo = hoursTwo + 'h ' + minutesTwo + 'm';
  
        // Third Flight Logic End
  
        flights = (
          <React.Fragment>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft 
                airlineCode={airlineCode} 
                operatingAirline={operatingAirline} 
                flightNumberInitial={flightNumberInitial} 
                flightNumberDigit={flightNumberDigit} 
                classType={classType}
                aircraftName={aircraftName}
                flightStatus={flightStatus} />
              <FlightInfoBoxInnerRight 
                departureTime={departureTime}
                origin={origin}
                originCity={originCity}
                dDate={dDate}
                departureMonthUpdated={dMonth}
                departureDayUpdated={dDay}
                originAirport={originAirport}
                departureTerminal={departureTerminal}
                durationTime={durationTime}
                destination={destination}
                destinationCity={originCityTwo}
                arrivalTime={arrivalTime}
                aDate={aDate}
                arrivalMonthUpdated={aMonth}
                arrivalDayUpdated={aDay}
                destinationAirport={destinationAirport}
                arrivalTerminal={arrivalTerminal}
                techStopover={techStopover}
                baggage={baggage}
                meal={meal}/>
            </FlightInfoBoxOuter>
            <div className={`phone-ml-0 mt-5 mb-5 pl-28Percent phone-pl-0`}>
              <InfoLabel type="layover" originCity={originCityTwo} layoverTime={layoverTimeOne} />
              {isTvOne ? <div className="mt-1"><InfoLabel type="transitVisa" originCity={originCityTwo} /></div> : null}
              {baggage === "Hand Baggage only" ? <div className="mt-1"><InfoLabel type="handBaggage" /></div> : null}
            </div>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft
                airlineCode={airlineCode}
                operatingAirline={operatingAirlineTwo}
                flightNumberInitial={flightNumberInitialTwo}
                flightNumberDigit={flightNumberDigitTwo}
                classType={classTypeTwo}
                aircraftName={aircraftNameTwo}
                flightStatus={flightStatusTwo}
                />
              <FlightInfoBoxInnerRight 
                departureTime={departureTimeTwo}
                origin={originTwo}
                originCity={originCityTwo}
                dDate={dDateTwo}
                departureMonthUpdated={dMonthTwo}
                departureDayUpdated={dDayTwo}
                originAirport={originAirportTwo}
                departureTerminal={departureTerminalTwo}
                durationTime={durationTimeTwo}
                destination={destinationTwo}
                destinationCity={originCityThree}
                arrivalTime={arrivalTimeTwo}
                aDate={aDateTwo}
                arrivalMonthUpdated={aMonthTwo}
                arrivalDayUpdated={aDayTwo}
                destinationAirport={destinationAirportTwo}
                arrivalTerminal={arrivalTerminalTwo}
                techStopover={techStopoverTwo}
                baggage={baggageTwo}
                meal={mealTwo}/>
            </FlightInfoBoxOuter>
            <div className={`phone-ml-0 mt-5 mb-5 pl-28Percent phone-pl-0`}>
              <InfoLabel type="layover" originCity={originCityThree} layoverTime={layoverTimeTwo} />
              {isTvTwo ? <div className="mt-1"><InfoLabel type="transitVisa" originCity={originCityThree} /></div> : null}
              {baggageTwo === "Hand Baggage only" ? <div className="mt-1"><InfoLabel type="handBaggage" /></div> : null}
            </div>
            <FlightInfoBoxOuter>
              <FlightInfoBoxInnerLeft
                airlineCode={airlineCode}
                operatingAirline={operatingAirlineThree}
                flightNumberInitial={flightNumberInitialThree}
                flightNumberDigit={flightNumberDigitThree}
                classType={classTypeThree}
                aircraftName={aircraftNameThree}
                flightStatus={flightStatusThree}
                />
              <FlightInfoBoxInnerRight 
                departureTime={departureTimeThree}
                origin={originThree}
                originCity={originCityThree}
                dDate={dDateThree}
                departureMonthUpdated={dMonthThree}
                departureDayUpdated={dDayThree}
                originAirport={originAirportThree}
                departureTerminal={departureTerminalThree}
                durationTime={durationTimeThree}
                destination={destinationThree}
                destinationCity={destinationCityThree}
                arrivalTime={arrivalTimeThree}
                aDate={aDateThree}
                arrivalMonthUpdated={aMonthThree}
                arrivalDayUpdated={aDayThree}
                destinationAirport={destinationAirportThree}
                arrivalTerminal={arrivalTerminalThree}
                techStopover={techStopoverThree}
                baggage={baggageThree}
                meal={mealThree}/>
            </FlightInfoBoxOuter>
            {baggageThree === "Hand Baggage only" ? <div className={`phone-ml-0 mb-5 pl-28Percent phone-pl-0`}><div className="mt-1"><InfoLabel type="handBaggage" /></div></div> : null}
            {props.isIntFlight ? <div className="mt-3"><Note>Passenger of all Nationalities are advised to confirm with respective embassies for all visa requirements.This communication is for informational &amp; general purposes only &amp; Yatra assumes no responsibility,legal or otherwise,of its applicability &amp; accuracy.</Note></div> : null}
          </React.Fragment>
        );
      }
    }
    return (
      <FlightInfoContainer>
        {flights}
      </FlightInfoContainer>
    );
  }

export default flightInfo;



// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfo.js